import { __assign, __awaiter, __generator } from "tslib";
import React, { useEffect } from "react";
import { serializeSchema } from "./helpers";
import "swagger-ui-dist/swagger-ui.css";

function createSwagger(schema, plugins) {
  return import("swagger-ui-dist").then(function (swagger) {
    var presets = [swagger.SwaggerUIBundle.presets.apis, plugins];
    var ui = swagger.SwaggerUIBundle({
      dom_id: "#swagger",
      spec: schema,
      presets: presets,
      requestInterceptor: function requestInterceptor(req) {
        var bearer = localStorage.getItem("bearer");
        req.headers = __assign(__assign({}, req.headers), {
          Authorization: bearer
        });
        return req;
      }
    });
    return ui;
  });
}

function prepareDataForCreate(schema, url) {
  var serializedSchema = serializeSchema(schema);

  if (url) {
    serializedSchema = __assign(__assign({}, serializedSchema), {
      host: url
    });
  }

  return serializedSchema;
}

export var OpenApiRenderEngine = function OpenApiRenderEngine(_a) {
  var source = _a.source,
      _b = _a.options,
      options = _b === void 0 ? {} : _b;
  useEffect(function () {
    var create = function create() {
      return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , createSwagger(prepareDataForCreate(source.content || source.rawContent, source.data && source.data.url || options.schemaUrl), options.plugins)];

            case 1:
              _a.sent();

              return [2
              /*return*/
              ];
          }
        });
      });
    };

    create();
  }, [source, options]);
  return React.createElement("div", {
    id: "swagger"
  });
};